import { render, staticRenderFns } from "./DQATable.vue?vue&type=template&id=64b475b2&scoped=true&"
import script from "./DQATable.vue?vue&type=script&lang=js&"
export * from "./DQATable.vue?vue&type=script&lang=js&"
import style0 from "./DQATable.vue?vue&type=style&index=0&id=64b475b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b475b2",
  null
  
)

export default component.exports